// extracted by mini-css-extract-plugin
module.exports = {"custom_button":"CustomButton_custom_button__6AwiK"};